import { fade } from 'material-ui/utils/colorManipulator';
import zIndex from 'material-ui/styles/zIndex';
import {
  white,
  darkBlack,
  fullBlack,
  grey100,
  grey300,
  grey400,
  grey500,
  cyan500,
  cyan700,
  lightBlack,
  pinkA200,
} from 'material-ui/styles/colors';

export default {
  spacing: {
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 16,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 64,
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 15,
    desktopDrawerMenuItemHeight: 48,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56,
  },
  zIndex: zIndex,
  fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", "Roboto", "Lucida Grande", sans-serif',
  palette: {
    primary1Color: '#E91E63',
    primary2Color: '#B6B6B6',
    primary3Color: '#C5CAE9',
    accent1Color: '#448AFF',
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: '#212121',
    alternateTextColor: '#fff',
    canvasColor: '#F6F6F6',
    borderColor: '#B6B6B6',
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: '#455A64',
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
  },
};



/** WEBPACK FOOTER **
 ** ./theme.js
 **/